<template>
  <v-app class="userpg" v-bind:class="{ xsOnly: $vuetify.breakpoint.xsOnly }">
    <v-content>
      <v-layout v-if="loading"
      align-center
      justify-space-around
      wrap
      fill-height
      style="background:var(--lightergrey);"
      >
      <v-progress-circular
          indeterminate
          color="primary"
          :size="50"
          >
          </v-progress-circular>
      </v-layout>
      <v-container v-else fill-height >
        <v-layout align-center>
          <v-flex>
            <div class="h-hold text-xs-center">
            <a class="h-logohold" href="https://tryworktabs.com">
              <div class="h-logo"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 255.21 255.12"><title>Logo</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="line" width="28.35" height="255.12"/><rect class="line" x="57.09" width="28.35" height="255.12"/><rect class="line" x="114.18" width="28.35" height="255.12"/><rect class="line" x="169.77" width="28.35" height="255.12"/><rect class="line" x="226.86" width="28.35" height="255.12"/></g></g></svg></div>
              <span class="logo-text">Worktabs</span>
            </a>
            <v-layout row v-if="error">
              <v-flex xs12>
                <app-alert @dismissed="onDismissed" :text="humanError"></app-alert>
              </v-flex>
            </v-layout>
            <div class="entrycard mb-4">
              <h1>Sign into your account</h1>
                      <form @submit.prevent="onSignin">
                            <v-text-field
                            name="email"
                            id="email"
                            v-model="email"
                            type="email"
                            label="email"
                            placeholder=" "
                            required>
                            </v-text-field>
                            <div class="pass-hold mt-4">
                            <v-text-field
                            autocomplete="Current password"
                            name="password"
                            id="password"
                            placeholder=" "
                            label="Password"
                            v-model="password"
                            type="password"
                            required>
                            </v-text-field>
                            <p class="pass-link"><router-link :to="{name: 'ForgotPassword'}" >forgotten password?</router-link></p>
                            </div>

                        <v-btn class="mt-4 mb-2" block large depressed color="primary" type="submit" :disabled="loading" :loading="loading">
                          <span class="body-2">Continue</span>
                          <span slot="loader" class="custom-loader">
                            <v-icon light>cached</v-icon>
                          </span>
                        </v-btn>
                      </form>
              </div>
              <p class="account-link pt-2 text-dark--text body text-xs-center">Don't have an account? <span style="cursor:pointer;" @click="goToSignup()" class="mutedprimary--text pr-2">Sign Up</span></p>
              <p class="account-link pt-2 text-dark--text body text-xs-center"><a href="https://tryworktabs.com/terms/" target="blank" class="mutedprimary--text">Privacy policy</a></p>

            </div>
            {{showEnv}}
          </v-flex>
        </v-layout>

      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      password: ''
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    group () {
      return this.$store.getters.group
    },
    error () {
      return this.$store.getters.error
    },
    humanError () {
      return this.$store.getters.getHumanError
    },
    loading () {
      return this.$store.getters.loading
    },
    showEnv () {
      const env = process.env.VUE_APP_ENVIRONMENT
      if (env === 'production') {
        return null
      }
      return env
    }
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        // if there is a billing issue go there
        let whereTo
        if (this.group.subscription.status === 'pastDue') {
          whereTo = '/settings/billing'
        } else {
        // if router query has a from then go there else go to the Home route
          const fromUrl = this.$route.query.from || '/'
          // also include queryparams if they exist
          let queryParams = ''
          if (typeof this.$route.query.queryparams !== 'undefined') {
            queryParams = this.$route.query.queryparams
          }
          whereTo = `${fromUrl}${queryParams}` || '/'
        }
        // this.$router.push(whereTo)
        setTimeout(() => this.$router.push(whereTo).catch(() => {}), 20)
      }
    }
  },
  methods: {
    onSignin () {
      // Vuex
      this.$store.dispatch('signUserIn', { email: this.email, password: this.password })
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    goToSignup () {
      this.$store.commit('clearError')
      this.$router.push('/sign-up')
    }
  },
  created () {
    // set the loader to show, then after 500milsec remove it.
    // this gives enough time for logged in users who have refreshed the root path /
    // to be logged in without the flasdh of the signin screen
    this.$store.commit('setLoading', true)
    setTimeout(() => {
      this.$store.commit('setLoading', false)
    }, 500)
  }
}
</script>

<style lang="scss">
.application.theme--light.userpg{
  background:var(--lightergrey) !important;
}
a.h-logohold{
  margin-bottom:40px;
    display:flex;
    justify-content: center;
    align-items: center;
  .logo-text{
    margin-left:10px;
    color:var(--mutedprimary);
    font-weight:700;
    font-size:2rem;
  }
    .h-logo{
      margin-top:-2px;
      width:15px;
      height:15px;
      rect{
        fill:var(--green);
      }
    }
}
.h-hold{
  max-width:480px;
  margin:0 auto;

  h1{
    font-family:"suisse_intl", Arial !important;
    font-size:1.6rem ;
    letter-spacing:0 !important;
    font-weight:700;
    text-align:left;
    margin-bottom:30px;
    .xsOnly &{
      font-size:1.2rem;
    }
  }
  a {
    text-decoration: none;
    color:var(--green);
  }
}
.entrycard{
  padding:50px 60px 50px;
  background:#ffffff;
  border-radius:7px;
  box-shadow: rgba(60, 66, 87, 0.08) 0px 15px 35px 0px, rgba(0, 0, 0, 0.12) 0px 5px 15px 0px;
.xsOnly &{
      padding:20px 30px 28px;
    }
  .theme--light.v-label{
    color: var(--mutedprimary);
    font-size:1.3rem;
    text-transform: capitalize;
    font-weight:bold;
  }
  .v-btn--large {
    height: 60px;
    text-transform: capitalize;
}
}
.pass-hold{
  position:relative;
}
.pass-link{
  position:absolute;
  top:-4px;
  right:0;
  .xsOnly &{
      position:relative;
      text-align:left;
    }
  a{
    color: var(--primary);
    font-size:1rem;
    text-transform: lowercase;
    font-weight:bold;
  }
}

</style>
